import { useEffect, useRef, useState, type ReactNode } from 'react';
import { cn } from '@/lib/utils';

export function AnimatedHeight({ children, className }: { children: ReactNode; className?: string }) {
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number | undefined>(undefined);

  useEffect(() => {
    const el = contentRef.current;
    if (!el || typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver(() => setHeight(el.offsetHeight));
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      className={cn('overflow-hidden transition-[height] duration-300 ease-out motion-reduce:transition-none', className)}
      style={{ height }}
    >
      <div ref={contentRef} className="flow-root">
        {children}
      </div>
    </div>
  );
}
